import { Navigate } from "react-router";
import { useIch } from "../api/ich";
import { Skeleton } from "../ui";

/** Einstieg: leitet je nach Sitzung in den passenden Bereich. */
export function Start() {
  const ich = useIch();
  if (ich.isPending) return <div className="app-zustand"><Skeleton lines={2} /></div>;
  if (ich.isError || !ich.data?.angemeldet) return <Navigate to="/anmelden" replace />;
  const b = ich.data.sitzung?.bereich ?? "laden";
  return <Navigate to={`/${b}`} replace />;
}

/** Schutz für Bereiche: ohne passende Sitzung → Anmelden. */
export function Geschuetzt({ bereich, children }: { bereich: "laden" | "mieter" | "admin" | "kasse"; children: React.ReactNode }) {
  const ich = useIch();
  if (ich.isPending) return <div className="app-zustand"><Skeleton lines={3} /></div>;
  if (ich.isError || !ich.data?.angemeldet) return <Navigate to={`/anmelden?ziel=${bereich}&weiter=${encodeURIComponent(window.location.pathname)}`} replace />;
  if (bereich === "admin" && !ich.data.benutzer?.istAnbieter) return <Navigate to="/" replace />;
  if ((bereich === "laden" || bereich === "admin") && ich.data.sitzung?.art === "web" && ich.data.totpAktiv && !ich.data.sitzung.zweiterFaktor) {
    return <Navigate to={`/anmelden/code?weiter=${encodeURIComponent(window.location.pathname)}`} replace />;
  }
  if ((bereich === "laden" || bereich === "kasse") && !ich.data.rolle) return <Navigate to="/" replace />;
  // Kassengerät (Gerätesitzung) kommt nur in die Kasse – Verwaltung/Admin verlangen den eigenen Anmeldelink
  if ((bereich === "laden" || bereich === "admin") && ich.data.sitzung?.art === "geraet") return <Navigate to={`/anmelden?ziel=${bereich}&weiter=${encodeURIComponent(window.location.pathname)}`} replace />;
  if (bereich === "mieter" && !ich.data.mieterIn?.length) return <Navigate to="/" replace />;
  return <>{children}</>;
}
